import React from 'react'

export default () => (
  <style
    type="text/css"
    dangerouslySetInnerHTML={{
      __html: `
.svgContainer {
  overflow: hidden;
}

.svgContainer:focus {
  outline: none;
}

.zoomMap {
  max-width: 80vh;
  width: 100%;
  height: auto;
  max-height: 80vh;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .zoomMap {
    max-width: 80vh;
    height: 80vh;
  }    
}

.zoomMap > g {
  transition: transform 500ms ease-in-out;
}

.gemeinde path {
  stroke: #000;
  stroke-width: 0.5px;
  transition: fill 300ms linear;
  cursor: pointer;
}

.gemeinde path:hover {
  stroke-width: 2px;
}

.bezirk path {
  fill: rgb(206, 206, 206);
  fill-opacity: 0;
  stroke: #474b47;
  stroke-width: 1.5px;
  stroke-linejoin: round;
  pointer-events: none;
  transition: fill-opacity 500ms linear;
}

.zoomedIn .bezirk path {
  fill-opacity: 0.5;
}

.zoomedIn .bezirk path.selected {
  fill-opacity: 0;
  pointer-events: none;
}

.bundesland path {
  fill: none;
  stroke: #181716;
  stroke-width: 1.5px;
  stroke-linejoin: round;
  pointer-events: none;
}

.overlay_bezirk {
  pointer-events: none;
  opacity: 1;
  transition: opacity 500ms linear;
}

.overlay_gemeinde {
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms linear;
}

.zoomedIn .overlay_bezirk {
  opacity: 0;
}

.zoomedIn .overlay_gemeinde {
  opacity: 1;
}

.zoomMap path {
  vector-effect: non-scaling-stroke;
}

.zoomHelper {
  opacity: 0;
  transition: opacity 500ms linear;
}

.zoomHelper.zoomedIn {
  opacity: 1;
}

.zoomHelper > circle {
  fill: none;
  stroke: #ccc;
  stroke-width: 4;
  vector-effect: none;
  pointer-events: none;
}

.zoomHelper .close circle {
  fill: #333;
  cursor: pointer;
}

.zoomHelper .close path {
  stroke-width: 8px;
  stroke: #fff;
  pointer-events: none;
  vector-effect: none;
}

.symbolAtlas text {
  text-anchor: middle;
  font-size: 14px;
  filter: url(#whiteblur);
}

.symbolAtlas .gemeinde path {
  transition: opacity 500ms linear;
  opacity: 0;
}

.symbolAtlas .zoomedIn .gemeinde path {
  opacity: 1;
}

.kooperationen path {
  stroke-width: 2.5px;
  stroke: #455a64;
  fill: none;
}

`,
    }}
  />
)



// WEBPACK FOOTER //
// ./src/components/SvgStyleSheet.js